import { useEffect } from "react";

export function usePageAnimations() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const elements = Array.from(document.querySelectorAll<HTMLElement>(
      "main > section:not(:first-child), main article, .pillar-grid > a, .service-list > div, .inner-grid > article, .contact-layout form > label, .portal-footer-grid > div"
    ));

    elements.forEach((element, index) => {
      element.classList.add("reveal-on-scroll");
      element.style.setProperty("--reveal-delay", `${Math.min(index % 4, 3) * 70}ms`);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px" });

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, []);
}
